module.exports = __webpack_public_path__ + "img/1.26a00d26.png";